/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkPackageTypeDto } from '../../models/work-package-type-dto';

export interface GetWorkPackageType$Params {
  id: string;
}

export function getWorkPackageType(http: HttpClient, rootUrl: string, params: GetWorkPackageType$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkPackageTypeDto>> {
  const rb = new RequestBuilder(rootUrl, getWorkPackageType.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkPackageTypeDto>;
    })
  );
}

getWorkPackageType.PATH = '/v0/workPackageTypes/{id}';
